export default __webpack_public_path__ + "static/media/ITER_GR5.8de32af9.79b9a562.pdf";